export class ExportLoanDocsFilter {
    filter: string = 'all';
    excludeNa: boolean = false;
    excludeCleared: boolean = false;
    exportPdf: boolean = false;
}